import FlightPlanBase from './FlightPlanBase.container';

export default FlightPlanBase;
